import { unwrapResult } from "@reduxjs/toolkit";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setActivePlan,
  setActiveUpsalePlan,
} from "src/redux/slices/plansSlice";
import { getUserSubscriptionThunk } from "src/redux/slices/userSlice";

export const useUserUpsalePlans = () => {
  const dispatch = useDispatch();
  const { userSubscription, isSubscriptionLoading } = useSelector(
    (state) => state.user
  );

  const { plans, isLoading, activeUpsalePlan } = useSelector(
    (state) => state.plans
  );

  const isAdditionalDiscount =
    localStorage.getItem("additionalDiscount") === "true";

  let planForUpsells;
  if (userSubscription) {
    planForUpsells = plans.find((plan) => {
      const mainPlanSubscription = userSubscription.find((item) => {
        return (
          item.subscriptionPlan.reference ===
          (isAdditionalDiscount ? plan.retentionReference : plan.reference)
        );
      });
      return (
        mainPlanSubscription?.subscriptionPlan?.reference ===
        (isAdditionalDiscount ? plan.retentionReference : plan.reference)
      );
    });
  }

  const upsalePlans = planForUpsells?.upsellsTo;


  useEffect(() => {
    let intervalId;

    const poll = async () => {
      const resultAction = await dispatch(getUserSubscriptionThunk());
      const data = unwrapResult(resultAction);

      if (!Array.isArray(data) || data.length > 0) {
        clearInterval(intervalId); 
      }
    };

    poll();
    intervalId = setInterval(poll, 500);
    return () => clearInterval(intervalId);
  }, [dispatch]);

  useEffect(() => {
    if (userSubscription) {
      const initialyFocusedPlan = upsalePlans?.find(
        (item) => item.uiDisplayOptions.focused
      );
      dispatch(setActiveUpsalePlan(initialyFocusedPlan));
      dispatch(setActivePlan(planForUpsells));
    }
  }, [userSubscription]);

  return {
    isLoading: isLoading,
    plans: upsalePlans,
    activePlan: activeUpsalePlan,
  };
};
